var map = {
	"./APRILYOS/logo.png": "8mI+",
	"./LNI/logo.png": "BlKN"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "FOZM";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*\/logo\.png$
// module id = FOZM
// module chunks = 0